import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useRef, useState } from 'react';
import { observer, Provider } from 'mobx-react';
import Modal, { CENTER } from '@/common/components/Modal/Modal';
import scrollTo from '@/common/helpers/scrollTo';
import PrivateAccessModalFooter from '@/security/components/PrivateAccessModal/PrivateAccessModalFooter/PrivateAccessModalFooter';
import PrivateAccessModalHeader from '@/security/components/PrivateAccessModal/PrivateAccessModalHeader/PrivateAccessModalHeader';
import PrivateAccessModalStore from '@/security/components/PrivateAccessModal/PrivateAccessModalStore';
import styles from './PrivateAccessModal.module.less';
import PrivateAccessModalContent from './PrivateAccessModalContent/PrivateAccessModalContent';
function PrivateAccessModal(props) {
    const { entities, type, isOpen, onClose, onSuccess } = props;
    const [privateAccessModalStore, setPrivateAccessModalStore] = useState(null);
    const contentRef = useRef(null);
    useEffect(() => {
        if (isOpen) {
            const newStore = new PrivateAccessModalStore(entities, type);
            newStore.refresh();
            setPrivateAccessModalStore(newStore);
        }
        else {
            setPrivateAccessModalStore(null);
        }
    }, [isOpen]);
    const handleAddForm = useCallback(() => {
        privateAccessModalStore.addForm();
        scrollTo(0, 0, contentRef.current);
    }, [privateAccessModalStore]);
    if (!privateAccessModalStore) {
        return null;
    }
    return (_jsx(Provider, { privateAccessModalStore: privateAccessModalStore, children: _jsx(Modal, { contentClassName: styles.personalAccessModal, disableClose: privateAccessModalStore?.isUpdating, isShowed: isOpen, onClose: onClose, position: CENTER, title: _jsx(PrivateAccessModalHeader, { targetCount: entities.length, targetType: type }), renderModalFooter: () => (_jsx(PrivateAccessModalFooter, { onClose: onClose, onAddForm: handleAddForm, onSuccess: onSuccess })), children: _jsx(PrivateAccessModalContent, { className: styles.content, ref: contentRef }) }) }));
}
export default observer(PrivateAccessModal);
